import { GPA, isEmpty, role, checkList } from "./constants";

const maxLimitReched = (val) => {
    const words = val?.split(/\s+/);
    if (words && words?.length <= 150) {
        return true;
    }
};

const inValidYear = (providedYear) => {
    const currentYear = new Date().getFullYear();
    const graduationYear = parseInt(providedYear, 10);
    if (isNaN(graduationYear) || graduationYear < currentYear - 5 || graduationYear > currentYear + 5) {
        return true;
    } else {
        return false;
    }
};

export const validateFormBasicInfo = (basicInfo, showSchool, showOther, user = "student") => {
    const isStudent = user === role.student ? true : false;
    const isMentor = user === role.mentor ? true : false;
    let errors = {};

    if (!basicInfo?.name?.trim()) {
        errors.name = "First name is required";
    }
    if (!basicInfo?.lastName?.trim()) {
        errors.lastName = "Last name is required";
    }
    if (!basicInfo?.mobile?.trim()) {
        errors.mobile = "Mobile number is required";
    }
     else if (isNaN(basicInfo?.mobile)) {
        errors.mobile = "Mobile number must be a number";
    }
    
    //below is more perfect usa validation for future purpose
    //!(/^(\+?1\s*[-.]\s*)?\(?\d{3}\)?[-.\s]*\d{3}[-.\s]*\d{4}$/).test(basicInfo.mobile)
    // else if (!(/^\(\d{3}\) \d{3}-\d{4}$/.test(basicInfo.mobile)) && !(/^\d{10}$/.test(basicInfo.mobile))) {
        else if ( !(/^\d{10,15}$/.test(basicInfo.mobile))) {
        errors.mobile = "Please enter a valid USA mobile number";
    }
    if (isStudent && basicInfo?.grade === "") {
        errors.grade = "Please select a grade";
    }
    if (!showSchool && (basicInfo?.school_id == null ||basicInfo?.school_id == "" || basicInfo?.school_id == "55ef2196-1c05-11ef-b24f-325096b39f47")) {
        errors.school_id = "Please select a school";
    }
    if (isMentor && basicInfo?.highschool_id === "") {
        errors.highschool_id = "Please select a high school";
    }
    if (isStudent && showSchool && !basicInfo?.other_school?.trim()) {
        errors.other_school = "School name is required";
    }

    if (isMentor && isEmpty(basicInfo?.gender?.trim())) {
        errors.gender = "Gender is required";
    }
    if (isMentor && isEmpty(basicInfo?.hometown?.trim())) {
        errors.hometown = "Hometown is required";
    }
    if (isMentor && isEmpty(basicInfo?.bio?.trim())) {
        errors.bio = "Bio is required";
    } else if (isMentor && !maxLimitReched(basicInfo?.bio?.trim())) {
        errors.bio = "Max 150 words allowed";
    }

    if (isMentor && isEmpty(basicInfo?.grad_year)) {
        errors.grad_year = "Graduation Year is required";
    } else if (isMentor && inValidYear(basicInfo?.grad_year)) {
        errors.grad_year = "Graduation Year should be within 5 years of the current year";
    }
    if (isMentor && isEmpty(basicInfo?.major?.trim())) {
        errors.major = "Major is required";
    }
    if (isMentor && isEmpty(basicInfo?.google_meet_link?.trim())) {
        errors.google_meet_link = "Google meet link is required";
    }
    if(isMentor && /^https:\/\/.+/.test(basicInfo?.google_meet_link?.trim()) === false){
        errors.google_meet_link = "Invalid Google link";
    }

    return errors;
};

export const validateFormBasicInfoOnChange = (basicInfo, showSchool, name, formErrors) => {
    let errors = { ...formErrors };
    if (name === 'name') {

        if (!basicInfo?.name?.trim()) {
            errors.name = "First name is required";
        } else {
            delete errors.name
        }
    }
    else if (name === 'lastName') {

        if (!basicInfo?.lastName?.trim()) {
            errors.lastName = "Last name is required";
        } else {
            delete errors.lastName
        }
    }
    else if (name === "mobile") {
        if (!basicInfo?.mobile?.trim()) {
            errors.mobile = "Mobile number is required";
        } 
        else if (isNaN(basicInfo?.mobile)) {
            errors.mobile = "Mobile number must be a number";
        }
        
        //below is more perfect usa validation for future purpose
        //!(/^(\+?1\s*[-.]\s*)?\(?\d{3}\)?[-.\s]*\d{3}[-.\s]*\d{4}$/).test(basicInfo.mobile)
        else if ( !(/^\d{10,15}$/.test(basicInfo.mobile))) {
            errors.mobile = "Please enter a valid mobile number";
        } else {
            delete errors.mobile
        }
    }

    else if (name === "grade") {
        if (basicInfo?.grade === "") {
            errors.grade = "Please select a grade";
        } else {
            delete errors.grade
        }
    }
    else if (name === "gender") {
        if (basicInfo?.gender === "") {
            errors.gender = "Please select a gender";
        } else {
            delete errors.gender
        }
    }
    else if (!showSchool && name === "school_id") {
        if (basicInfo?.school_id == "" || basicInfo?.school_id == null ) {
            errors.school_id = "Please select a school";
        } else {
            delete errors.school_id
        }
    }
    else if (name === "highschool_id") {
        if (basicInfo?.highschool_id === "") {
            errors.highschool_id = "Please select a high school";
        } else {
            delete errors.highschool_id
        }
    }
    else if (showSchool && name === "other_school") {
        if (!basicInfo?.other_school?.trim()) {
            errors.other_school = "School name is required";
        } else {
            delete errors.other_school
        }
    }
    else if (name === "hometown") {
        if (isEmpty(basicInfo?.hometown?.trim())) {
            errors.hometown = "Hometown is required";
        } else {
            delete errors.hometown
        }
    }
    else if (name === "grad_year") {
        if (isEmpty(basicInfo?.grad_year?.trim())) {
            errors.grad_year = "Graduation Year is required";
        } else if (inValidYear(basicInfo?.grad_year?.trim())) {
            errors.grad_year = "Graduation Year should be within 5 years of the current year.";
        } else {
            delete errors.grad_year
        }
    } else if (name === "bio") {
        if (isEmpty(basicInfo?.bio?.trim())) {
            errors.bio = "Bio is required";
        } else if (!maxLimitReched(basicInfo?.bio?.trim())) {
            errors.bio = "Max 150 words allowed";
        } else {
            delete errors.bio
        }
    } else if (name === "major") {
        if (isEmpty(basicInfo?.major?.trim())) {
            errors.major = "Major is required";
        } else {
            delete errors.major
        }
    } else if (name === "google_meet_link") {
        if (isEmpty(basicInfo?.google_meet_link?.trim())) {
            errors.google_meet_link = "Google link is required";
        } else if(/^https:\/\/.+/.test(basicInfo?.google_meet_link?.trim()) === false){
            errors.google_meet_link = "Invalid Google link";
        } else {
            delete errors.google_meet_link
        }
    }
    return errors;
};

export const validateFormAcadmicBackground = (acadmicBackground, questionOneTwo, isRadioSelected) => {
    let errors = {};
    if (!isRadioSelected) {
        errors.radio = GPA?.radio_selected;
    }

    if (questionOneTwo === 3) {
        delete errors.act_score;
        if (!acadmicBackground?.sat_score || isNaN(acadmicBackground?.sat_score)) {
            errors.sat_score = GPA?.sat_score_number;
        }
        if (acadmicBackground?.sat_score < 400 || acadmicBackground?.sat_score > 1600) {
            errors.sat_score = GPA?.sat_score_range;
        }

    }
    if (questionOneTwo === 4) {
        delete errors.sat_score;
        if (isNaN(acadmicBackground?.act_score)) {
            errors.act_score = GPA?.act_score_number;
        }
        if (acadmicBackground?.act_score < 1 || acadmicBackground?.act_score > 36) {
            errors.act_score = GPA?.act_score_range;
        }

    }
    return errors;
};

export const validateFormAcadmicBackgroundOnChange = (acadmicBackground, name, formErrors) => {
    let errors = { ...formErrors };

    if (name === "unweighted_gpa") {
        if (isNaN(acadmicBackground?.unweighted_gpa?.trim())) {
            errors.unweighted_gpa = GPA?.unweighted_isNumber;
        } else if (acadmicBackground?.unweighted_gpa?.trim() < 0 || acadmicBackground?.unweighted_gpa?.trim() > 4.00) {
            errors.unweighted_gpa = GPA?.unweighted_range;
        } else {
            delete errors.unweighted_gpa
        }
    }

    if (name === "weighted_gpa") {
        if (isNaN(acadmicBackground?.weighted_gpa)) {
            errors.weighted_gpa = GPA?.weightted_isNumber;
        }
        else if (acadmicBackground?.weighted_gpa < 0 || acadmicBackground?.weighted_gpa > 6.00) {
            errors.weighted_gpa = GPA?.weighted_range;
        } else {
            delete errors.weighted_gpa
        }
    }

    if (name === "radio") {
        delete errors.radio;
    }

    if (name === "sat_score") {
        // delete errors.act_score;
        if (isNaN(acadmicBackground?.sat_score)) {
            errors.sat_score = GPA?.sat_score_number;
        } else if (acadmicBackground?.sat_score < 400 || acadmicBackground?.sat_score > 1600) {
            errors.sat_score = GPA?.sat_score_range;
        } else {
            delete errors.sat_score;
        }

    }

    if (name === "act_score") {
        // delete errors.sat_score;
        if (isNaN(acadmicBackground?.act_score)) {
            errors.act_score = GPA?.act_score_number;
        }
        else if (acadmicBackground?.act_score < 1 || acadmicBackground?.act_score > 36) {
            errors.act_score = GPA?.act_score_range;
        } else {
            delete errors.act_score;
        }

    }
    return errors;
};

export const isValidUrl = (url) => {
    const urlRegex = /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w.-]*)*\/?$/;
    const domainRegex = /^https:\/\/calendly\.com/;
    return urlRegex.test(url) && domainRegex.test(url);
};

export const validateAcademicBackgroundFormData = (acadmicBackground) => {
    let errors = {};
    if (!acadmicBackground?.unweighted_gpa || isNaN(acadmicBackground?.unweighted_gpa)) {
        errors.unweighted_gpa = GPA?.unweighted_isNumber;
    }
    if (!acadmicBackground?.unweighted_gpa || (acadmicBackground?.unweighted_gpa < 0 || acadmicBackground?.unweighted_gpa > 4.00)) {
        errors.unweighted_gpa = GPA?.unweighted_range;
    }

    if (!acadmicBackground?.weighted_gpa || isNaN(acadmicBackground?.weighted_gpa)) {
        errors.weighted_gpa = GPA?.weightted_isNumber;
    }
    if (!acadmicBackground?.weighted_gpa || (acadmicBackground?.weighted_gpa < 0 || acadmicBackground?.weighted_gpa > 6.00)) {
        errors.weighted_gpa = GPA?.weighted_range;
    }
    return errors;
};

export const validateChecklistFields = (selectedOption, searchUniversity, taskDueDate, taskName, formErrors) => {
    let errors = { ...formErrors };
    if (!selectedOption) {
        errors.task_name = checkList?.task_name;
    }

    if (!searchUniversity?.name) {
        errors.college_name = checkList?.college_name;
    }

    if (!taskDueDate) {
        errors.due_date = checkList?.due_date;
    }
    if (!taskName && selectedOption === "Other") {
        errors.other_task_name = checkList?.other_task_name;
    }
    return errors;

};

export const validatePremadeChecklistFields = (formErrors, selectedPremadeOption) => {
    let errors = { ...formErrors };

    if (!selectedPremadeOption) {
        errors.premade_checklist = checkList?.premade_checklist;
    }
    return errors;
};

export const validateComment = (comment, formErrors) => {
    let errors = { ...formErrors };

    if (!comment) {
        errors.comment = checkList?.comment;
    }

    return errors;

};

export const validateDefaultChecklist = (task_name, formErrors) => {
    let errors = { ...formErrors };
    if (task_name) {
        errors.duplicate_task_name = checkList?.duplicate_task_name;
    }

    return errors;

};

export const handleErrorForUploadStudent = (formData, setFormErrors, user_type) => {
    const errors = {};
  
    if (!formData.file) {
      errors.file = 'Upload file is required';
    }
  
    if (!formData.district_id && user_type !== role.mentor) {
      errors.district_id = 'District is required';
    }
  
    if (!formData.document_credits_for_student && user_type === role.student) {
      errors.document_credits_for_student = 'Document credits are required';
    }
  
    if (!formData.meeting_credits_for_student && user_type === role.student) {
      errors.meeting_credits_for_student = 'Meeting credits are required';
    }
  
    if (!formData.total_meetings_credits && user_type !== role.mentor) {
      errors.total_meetings_credits = 'Total meeting credits are required';
    }
  
    if (!formData.total_documents_credits && user_type !== role.mentor) {
      errors.total_documents_credits = 'Total document credits are required';
    }
  
    setFormErrors(errors);
    return Object.keys(errors).length !== 0;
  };

export const handleErrorCantEditDoc = (formData, setFormErrors, isB2B) => {
    const errors = {};
    if(!formData.rejection_reason){
      errors.rejection_reason = 'Rejection reason is required';
    }
    if(!formData.proposed_date && isB2B){
        errors.proposed_date = "Date is required";
    }
    setFormErrors(errors);
    return Object.keys(errors).length !== 0;
}